"use client";
import Link from "next/link";
export default function PageComponent({sectionTitle,slug}) {
  return (
    <main className="page page-contact-complete">
      <div className="container-s">
        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="title en">Thank You!</span>
          </h1>
          <div className="text-lead bold">
            お問い合わせいただき、ありがとうございます。<br />
            追って担当者よりご連絡いたします。
          </div>
        </div>

        <div className="button-holder">
          <Link className="button-round scaleHover size-s bold" href="/">
            <span className="inner">TOPにもどる</span>
          </Link>
        </div>
      </div>
    </main>
  );
}
